import {useEffect, useRef, useState} from "react";
import Lot from "../Lot";
import FloorPainterBox from "./FloorPainterBox";
import styled from "styled-components";

const PreviewStyled = styled.div`
  position: absolute;
  bottom: 5px;
  background-color: rgba(204, 204, 204, 0.614);
  right: 5px;
`;

const WrapperStyled = styled.div`
  padding: 5px;
  position: relative;
  height: 100%;
`;


const PaintBoxStyled = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  cursor: grab;
`;

export default function FloorPainter(props) {
    const ref = useRef(null);

    const {drawCircles = true, site, floorPos, circles, shoppers_list, draw_shoppers_image, indications} = props;

    const [previewMousePosition, s_previewMousePosition] = useState({x: 0, y: 0});
    const [isMouseDown, s_isMouseDown] = useState(false);
    const [startX, s_startX] = useState(0);
    const [startY, s_startY] = useState(0);


    if (site == null) return <Lot>loader</Lot>;
    if (!site?.[floorPos]?.floor) return <Lot>emptyState</Lot>;

    return (
        <WrapperStyled>
            <PaintBoxStyled id={'hold'}
                            ref={ref}
                            onMouseDown={(event) => {
                                s_isMouseDown(true);
                                s_startX(event.clientX);
                                s_startY(event.clientY);
                            }}
                            onMouseUp={() => {
                                s_isMouseDown(false);
                            }}
                            onMouseMove={(e) => {
                                // const {top, left} = ref.current.getBoundingClientRect();
                                // const positionX = e.clientX - left + ref.current.scrollLeft;
                                // const positionY = e.clientY - top + ref.current.scrollTop;
                                // s_previewMousePosition({x: positionX, y: positionY});
                                if (isMouseDown) {
                                    const scrollX = startX - e.clientX;
                                    const scrollY = startY - e.clientY;
                                    ref.current.scrollLeft += scrollX;
                                    ref.current.scrollTop += scrollY;
                                    s_startX(e.clientX);
                                    s_startY(e.clientY);
                                }
                            }}
            >
                
                <FloorPainterBox
                    site={site}
                    indications={indications}
                    floorPos={floorPos}
                    circles={circles}
                    drawCircles={drawCircles}
                    shoppers_list={shoppers_list}
                    draw_shoppers_image={draw_shoppers_image}
                />
            </PaintBoxStyled>

            {/* <PreviewStyled>*/}
            {/*    <FloorPainterBox*/}
            {/*        parentWidth={ref?.current?.clientWidth}*/}
            {/*        parentHeight={ref?.current?.clientHeight}*/}
            {/*        site={site}*/}
            {/*        floorPos={floorPos}*/}
            {/*        previewMousePosition={previewMousePosition}*/}
            {/*        circles={circles}*/}
            {/*        drawCircles={drawCircles}*/}
            {/*        shoppers_list={shoppers_list}*/}
            {/*        draw_shoppers_image={draw_shoppers_image}*/}
            {/*        miniMode={true}*/}
            {/*    />*/}
            {/*</PreviewStyled> */}
        </WrapperStyled>
    );
}